import AlarmService from "~/services/AlarmService"

export default function({ $api, $store }, inject) {
  const alarm = new AlarmService($api, $store)
  inject("alarm", alarm)
}
